import produce from "immer";
import { useCallback, useState } from "react";
export function useImmerState(initialValue) {
    const [state, setState] = useState(initialValue);
    return [
        state,
        // the immer way "updateDraft"
        useCallback((updater) => {
            // @ts-ignore
            setState((state) => produce(state, updater));
        }, []),
        // the normal useState + object freeze way "replaceDraft"
        useCallback((update) => {
            // @ts-ignore
            setState((state) => produce(state, (draft) => update));
        }, []),
        // the object assign way "assignDraft"
        useCallback((update) => {
            setState((state) => produce(state, (draft) => void Object.assign(draft, update)));
        }, []),
    ];
}
//# sourceMappingURL=useImmerState.js.map